import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  MaterialIcon,
  SVGIcon,
} from '@pearsontechnology/aero-components';

import { getIcon } from 'Workspace/helpers';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import {
  InputKeys,
  KnowledgeTypes,
  KnowledgeMapIconIds,
  MAXIMUM_TITLE_LENGTH,
  PRESENTATION_ROLE,
} from 'constants/knowledgeMap';
import {
  DetailsDrawerHeader,
  DetailsDrawerContainer,
  DetailsDrawerContent,
  DetailsDrawerTitleTextarea,
  DetailsDrawerTitleWrapper,
  TitleErrorInfo,
} from './styles';
import messages from './messages';

const EditRootDrawer = ({ knowledgeMap, onClose = () => {}, onChangeItem }) => {
  const { SUBMIT_INPUT, PANEL_CLOSE } = KnowledgeMapIconIds;
  const [title, setTitle] = useState(knowledgeMap.title);
  const [enableTitleTextarea, setEnableTitleTextarea] = useState(false);
  const [emptyTitleField, setEmptyTitleField] = useState(false);

  const handleOnClose = () => {
    onClose();
  };

  const handleOnChange = (event) => {
    setTitle(event.target.value);
  };

  const handleOnBlur = () => {
    setEnableTitleTextarea(false);
    setTitle(knowledgeMap.title);
  };

  const handleKeyDown = (event) => {
    const { ESCAPE_KEY, ENTER_KEY } = InputKeys;
    const { key } = event;

    if (key === ESCAPE_KEY) {
      handleOnBlur();
    } else if (key === ENTER_KEY) {
      updateValue();
    }
  };

  const titleClickHandler = () => {
    setEnableTitleTextarea(true);
  };

  const handleSubmitMouseDown = (event) => event.preventDefault();

  const updateValue = () => {
    if (!onChangeItem) return;
    if (title != knowledgeMap.title && !title) {
      setEmptyTitleField(true);
      return;
    }
    onChangeItem({ title });
    setEnableTitleTextarea(false);
    setEmptyTitleField(false);
  };

  return (
    <DetailsDrawerContainer>
      <DetailsDrawerHeader>
        <DetailsDrawerHeader.RightActionsGroup>
          <Button iconOnly grey onClick={handleOnClose}>
            <MaterialIcon id={PANEL_CLOSE} />
          </Button>
        </DetailsDrawerHeader.RightActionsGroup>
      </DetailsDrawerHeader>
      <DetailsDrawerContent>
        <DetailsDrawerTitleWrapper>
          <DetailsDrawerTitleTextarea
            labelHidden
            label={intl.formatMessage(messages.titleLabel)}
            value={title}
            placeholder={intl.formatMessage(messages.titlePlaceholder)}
            maxLength={MAXIMUM_TITLE_LENGTH}
            onChange={handleOnChange}
            onKeyDown={handleKeyDown}
            onClick={titleClickHandler}
            onBlur={handleOnBlur}
            readOnly={!enableTitleTextarea}
          />
          {enableTitleTextarea && (
            <span role={PRESENTATION_ROLE}>
              <MaterialIcon
                onMouseDown={handleSubmitMouseDown}
                onClick={updateValue}
                id={SUBMIT_INPUT}
              />
            </span>
          )}
          {emptyTitleField && (
            <TitleErrorInfo>
              <SVGIcon
                icon={getIcon(KnowledgeTypes.WARNING_CIRCLE)}
                viewBox="0 0 24 24"
              />
              {intl.formatMessage(messages.emptyTitle)}
            </TitleErrorInfo>
          )}
        </DetailsDrawerTitleWrapper>
      </DetailsDrawerContent>
    </DetailsDrawerContainer>
  );
};

EditRootDrawer.propTypes = {
  knowledgeMap: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeItem: PropTypes.func.isRequired,
};

export default EditRootDrawer;
